import { isServerSide } from '../../utils/isServerSide';

export function getCurrentSearch() {
	if (isServerSide()) {
		return undefined;
	}
	const { search } = window.location;

	return new URLSearchParams(search) || undefined;
}
